module.exports = __webpack_public_path__ + "static/img/tpybx.c997f4ef.png";